import { Component, OnInit } from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ApiService} from '../services/api.service';
import {AppComponent} from '../app.component';
import {ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-update-department-limit',
  templateUrl: './update-department-limit.component.html',
  styleUrls: ['./update-department-limit.component.scss']
})
export class UpdateDepartmentLimitComponent implements OnInit {
  form: FormGroup;
  formOtp: FormGroup;
  formMode = 'Add';
  deptt_id;
  department_limit_change_id;

  changeForm = true;

  constructor(
    private _formBuilder: FormBuilder,
    private apiService : ApiService, 
    private appComponent: AppComponent, 
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private appComponet: AppComponent,

    ) {
   
  }

  ngOnInit() {
   this.deptt_id = this.activatedRoute.snapshot.params['id'];
   this.createForm();
  }

  


  createForm() {
    this.form = this._formBuilder.group({
      mobile_no: ['', [
        Validators.required,
        Validators.pattern(/^[0-9]{10}$/),
        this.removeSpaces
      ]],
      department_id: [this.deptt_id]
    });
  }

  createOtpForm() {
    this.formOtp = this._formBuilder.group({
      otp: ['', [
        Validators.required,
        Validators.pattern(/^[0-9]{4}$/),
        this.removeSpaces
      ]],
      department_limit_change_id:[this.department_limit_change_id]
  });
   
  }

  removeSpaces(control: AbstractControl) {
    if (control && control.value && !control.value.replace(/\s/g, '').length) {
      control.setValue('');
    }
    return null;
  }
  


  saveData() {
    const formObj = this.form.getRawValue();
    let department_limit: any[]

    this.appComponent.showLoader();
      this.apiService.postDataToServer('/department_limit_update/initiate', formObj).subscribe(
        res => {
          this.department_limit_change_id = res['data'].id;
          console.log(this.department_limit_change_id);
          this.appComponent.hideLoader();
          this.appComponent.showMessageAlert(res['message'], 'success');
          this.createOtpForm();
          this.changeForm = false;
          // this.close();
        },
        err => {
          this.appComponent.hideLoader();
          this.appComponent.showMessageAlert(err.error.error[0].message, 'error');
          console.log(err);
        }
      );
  }

  saveOtpData() {
    const formObj = this.formOtp.getRawValue();

    this.appComponent.showLoader();
      this.apiService.postDataToServer('/department_limit_update/verify_and_update', formObj).subscribe(
        res => {
          console.log(res);
          this.appComponent.hideLoader();
          this.appComponent.showMessageAlert(res['message'], 'success');
          // this.createOtpForm();
          this.close();
        },
        err => {
          this.appComponent.hideLoader();
          this.appComponent.showMessageAlert(err.error.error[0].message, 'error');
          console.log(err);
        }
      );
  }

  close() {
    this.router.navigate(['/update-department-limit']);

  }

}
